import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lightbox from './../../../lightbox/Lightbox';
import helpContent from './helpContent.json';
import { getLang } from './../../../../redux/helpers/getParams';
import './help.css';

class Help extends Component {
  constructor(args) {
    super(args);
    this.help = this.changeDropDown.bind(this);
    this.hideDropDown = this.hideDropDown.bind(this);

    this.state = {
      opened: false,
      lightboxOpened: false,
      videoId: '',
      content: '',
    };
  }

  setLightbox = () => {
    this.setState({
      lightboxOpened: false,
      opened: false,
    });
  }


  changeDropDown = () => {
    const { opened } = this.state;
    this.setState({
      opened: !opened,
    });
  }

  hideDropDown = () => {
    this.setState({
      opened: false,
    });
  }

  showContent = (element) => {
    const language = getLang();
    const { youTubeVideoId, content } = element[language];
    const videoId = 'youTubeVideoId' in element[language] ? youTubeVideoId : '';
    this.setState({
      videoId,
      lightboxOpened: true,
      content,
    });
  }

  renderHelpContent = () => {
    const { lang } = this.props;
    const elements = Object.entries(helpContent).map(element => (
      <button
        key={`btn-${element}`}
        className="dropdown-btn"
        onMouseDown={() => this.showContent(element[1])}
        type="button"
      >
        {lang[element[0]]}
      </button>
    ));
    return elements;
  }

  render() {
    const { lang } = this.props;

    const {
      opened, lightboxOpened, videoId, content,
    } = this.state;
    const show = opened ? 'show' : '';

    return (
      <div className="marginWrapper help">
        <button
          className="help-btn green-btn"
          onClick={this.changeDropDown}
          onBlur={this.hideDropDown}
        >
          <svg
            width="16"
            height="16"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
          >
            <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0ZM8,15a7,7,0,1,1,7-7A7,7,0,0,1,8,15Zm-.15-3.41a.73.73,0,0,0-.55.2.76.76,0,0,0-.18.51.71.71,0,0,0,.18.5.73.73,0,0,0,.55.2.74.74,0,0,0,.55-.2.68.68,0,0,0,.19-.5.72.72,0,0,0-.19-.51A.74.74,0,0,0,7.85,11.59ZM10,3.69a2.33,2.33,0,0,0-.85-.51A3.33,3.33,0,0,0,8,3,3.46,3.46,0,0,0,7,3.16a2.63,2.63,0,0,0-.87.48,2.36,2.36,0,0,0-.59.77,2.55,2.55,0,0,0-.22,1H6.52a1.34,1.34,0,0,1,.12-.6A1.28,1.28,0,0,1,7,4.41a1.49,1.49,0,0,1,.49-.24A2.12,2.12,0,0,1,8,4.09a1.36,1.36,0,0,1,1.07.4A1.57,1.57,0,0,1,9.48,5.6a1.85,1.85,0,0,1-.09.6,2.06,2.06,0,0,1-.25.49,4.8,4.8,0,0,1-.37.44l-.44.44c-.22.22-.4.42-.55.6a3,3,0,0,0-.35.55,2.25,2.25,0,0,0-.19.62,4.86,4.86,0,0,0-.07.83H8.41a3.48,3.48,0,0,1,.13-.93A1.71,1.71,0,0,1,9,8.47c.21-.2.42-.41.62-.62a5,5,0,0,0,.55-.68,4.49,4.49,0,0,0,.38-.76,2.61,2.61,0,0,0,.14-.85,3,3,0,0,0-.18-1.06A2.13,2.13,0,0,0,10,3.69Z" />
          </svg>
          {lang.help}
        </button>
        <div className={`dropdown-menu ${show}`}>
          { this.renderHelpContent() }
        </div>
        { lightboxOpened &&
          <Lightbox
            videoLink={videoId}
            setLightBox={this.setLightbox}
            content={content}
            lang={lang}
          />}
      </div>
    );
  }
}


Help.defaultProps = {
  lang: {},
};

Help.propTypes = {
  lang: PropTypes.object,
};

export default (Help);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/help/help.jsx